import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useSettings } from "@/context/SettingsContext";

export default function ContentPoliciesCard() {
  const { contentPolicies, setContentPolicies } = useSettings();

  return (
    <Card id="content-policies">
      <CardHeader>
        <CardTitle>Content policies</CardTitle>
        <CardDescription>
          Define content policies and guidelines for content generation
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="content-policies">
            Content Policies & Guidelines
          </Label>
          <Textarea
            id="content-policies"
            value={contentPolicies}
            onChange={(e) => setContentPolicies(e.target.value)}
            placeholder="Enter any content policies or guidelines that should be followed when generating content..."
            className="min-h-[200px]"
          />

          <div className="flex justify-end">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setContentPolicies("")}
            >
              Restore Default
            </Button>
          </div>
        </div>
        <p className="text-sm text-muted-foreground">
          Specify content policies, guidelines, or restrictions that should be
          followed when generating content. This helps ensure all content aligns
          with your brand standards and compliance requirements.
        </p>
      </CardContent>
    </Card>
  );
}
